import PushNotificationService from "services/PushNotificationService";
import * as Sentry from "@sentry/react";

const initPushNotifications = async () => {
  if (!("Notification" in window) || Notification.permission === "denied") {
    return;
  }

  try {
    const serviceWorkerRegistration = await navigator.serviceWorker.ready;

    if (!serviceWorkerRegistration) {
      throw new Error("ServiceWorkerRegistration not found");
    }

    const subscription =
      await serviceWorkerRegistration.pushManager.getSubscription();

    const { data } =
      await PushNotificationService.getNotificationSubscription();

    const serverEndpoint = data?.subscription
      ? (JSON.parse(data.subscription) as { endpoint?: string }).endpoint
      : null;
    const browserEndpoint = subscription?.endpoint ?? null;

    if (
      !serverEndpoint ||
      !browserEndpoint ||
      serverEndpoint !== browserEndpoint
    ) {
      await PushNotificationService.unsubscribePushNotification();
      await PushNotificationService.initPushSubscription();
    }
  } catch (error) {
    console.error("Failed to initialize push notifications:", error);
    Sentry.captureException(error);
  }
};

export default initPushNotifications;
